var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"field",staticClass:"form-control",attrs:{"name":_vm.name,"required":_vm.required,"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }